import { MODAL_STEPS } from "./modal";

export interface LingerieQuestionOption {
  id: string;
  translationKey: string;
}

export interface LingerieQuestionConfig {
  apiField: string;
  stepKey: keyof typeof MODAL_STEPS;
  translationPrefix: string;
  options: LingerieQuestionOption[];
}

export const LINGERIE_QUESTIONS: LingerieQuestionConfig[] = [
  {
    apiField: "hook_position",
    stepKey: "LINGERIE_QUESTION_1",
    translationPrefix: "question1",
    options: [
      { id: "tightest", translationKey: "size1" },
      { id: "middle", translationKey: "size2" },
      { id: "loosest", translationKey: "size3" },
    ],
  },
  {
    apiField: "band_fit",
    stepKey: "LINGERIE_QUESTION_2",
    translationPrefix: "question2",
    options: [
      { id: "tight", translationKey: "size1" },
      { id: "perfect", translationKey: "size2" },
      { id: "loose", translationKey: "size3" },
    ],
  },
  {
    apiField: "cup_fit",
    stepKey: "LINGERIE_QUESTION_3",
    translationPrefix: "question3",
    options: [
      { id: "tight", translationKey: "size1" },
      { id: "perfect", translationKey: "size2" },
      { id: "loose", translationKey: "size3" },
    ],
  },
  {
    apiField: "underwire_fit",
    stepKey: "LINGERIE_QUESTION_4",
    translationPrefix: "question4",
    options: [
      { id: "tight", translationKey: "size1" },
      { id: "perfect", translationKey: "size2" },
      { id: "loose", translationKey: "size3" },
    ],
  },
  {
    apiField: "front_band",
    stepKey: "LINGERIE_QUESTION_5",
    translationPrefix: "question5",
    options: [
      { id: "not_touching", translationKey: "size1" },
      { id: "touching", translationKey: "size2" },
    ],
  },
  {
    apiField: "strap_fit",
    stepKey: "LINGERIE_QUESTION_6",
    translationPrefix: "question6",
    options: [
      { id: "digging", translationKey: "size1" },
      { id: "stays_on_shoulders", translationKey: "size2" },
      { id: "slipping", translationKey: "size3" },
    ],
  },
];

export type LingerieAnswers = Record<string, string | null>;

export const emptyLingerieAnswers = (): LingerieAnswers =>
  Object.fromEntries(LINGERIE_QUESTIONS.map((q) => [q.apiField, null]));

export const buildLingeriePayload = (
  answers: LingerieAnswers,
  userData: { age: number; height: number; weight: number; cup: string | null; band: string | null },
) => ({
  age: userData.age,
  height: userData.height,
  weight: userData.weight,
  bra_size: { cup: userData.cup, band: userData.band },
  ...Object.fromEntries(
    LINGERIE_QUESTIONS.map((q) => [
      q.apiField,
      { status: "answered", value: answers[q.apiField] },
    ]),
  ),
});
